import { createSelector } from 'reselect';
import { getHvacConfig } from 'src/modules/hvac/selectors/getHvacConfig';
import { getHvacData } from 'src/modules/hvac/selectors/getHvacData';
import { mapHvacStoreToForm } from 'src/modules/hvac/utils/mapHvacStoreToForm';

export const getHvacAssesmentFormData = createSelector([
  getHvacData,
  getHvacConfig,
], mapHvacStoreToForm);
